import '../css/chatbot.css';
import { ChatbotUI } from './ui';
import { sendMessage } from './api';

/**
 * Chatbot Widget main class
 */
class JsimpleBot {
    /**
     * Creates a new JsimpleBot instance
     * @param {Object} config - Configuration options
     */
    constructor() {
        this.config = {
            // apiUrl: 'http://localhost:5271/api/AISearch/ask-bot',//''https://app.captivue.ai/api/AISearch/ask-bot', // Default API URL //'http://localhost:5271/api/AISearch/ask-bot',
            apiUrl: 'https://lambda.jsimple.com/quess',//''https://app.captivue.ai/api/AISearch/ask-bot', // Default API URL //'http://localhost:5271/api/AISearch/ask-bot',
            domain: '', // Required
            email: '', 
            botName: 'AI Assistant',
            primaryColor: '#5c6bc0',
            welcomeMessage: "Welcome! I'm Mira, here to help you get the most from Captivue. Ask anything!",
            placeholderText: 'Type a message...',
            position: 'left', // 'right' or 'left'
            type: '',  // flag to check login or not
        };

        this.ui = null;
        this.conversationHistory = [];
        this.isInitialized = false;
    }

    /**
     * Initializes the chatbot widget
     * @param {Object} config - Configuration options
     */
    init(config = {}) {
        // Prevent multiple initializations
        if (this.isInitialized) {
            console.warn('JsimpleBot is already initialized');
            return;
        }

        // Merge config with defaults
        this.config = { ...this.config, ...config };

        // Validate required config
        if (!this.config.domain) {
            console.error('JsimpleBot: domain is required');
            return;
        }

        // if (!this.config.email) {
        //     console.error('JsimpleBot: email is required');
        //     return;
        // }

        // Initialize UI
        this.ui = new ChatbotUI({
            botName: this.config.botName,
            primaryColor: this.config.primaryColor,
            position: this.config.position,
            welcomeMessage: this.config.welcomeMessage,
            type: this.config.type,
            apiUrl:this.config.apiUrl,
            domain:this.config.domain,
            emial:this.config.email
        });

        // Initialize UI elements
        const elements = this.ui.init();

        // Register event handlers
        this.ui.on('sendMessage', (message) => this.handleUserMessage(message));
        this.ui.on('open', () => this.handleChatOpen());

        // Set placeholder text
        elements.inputContainer.querySelector('.chatbot-input').placeholder = this.config.placeholderText;

        // Mark as initialized
        this.isInitialized = true;

        // Check API availability
        //this.checkApiStatus();

        return this;
    }

    /**
     * Handles when a user sends a message
     * @param {string} message - The user message
     */
    async handleUserMessage(message) {
        // Add user message to UI
        this.ui.addMessage(message, 'user');

        // Add to conversation history
        this.conversationHistory.push({
            role: 'user',
            content: message
        });

        // Show typing indicator
        this.ui.showTypingIndicator();

        try {
            // Send message to API
            // const response = await sendMessage(
            //     this.config.apiUrl,
            //     message,
            //     this.config.domain,
            //     this.config.email,
            //     this.config.type,
            //     this.conversationHistory
            // );
            const response = "It seems you need further assistance. Please reach out to our support team for help.";
            // Hide typing indicator
            this.ui.hideTypingIndicator();
            //console.log(response.answer);
if(response=="It seems you need further assistance. Please reach out to our support team for help."){
                this.ui.saveCustomerMessage(message);
                console.log(this.conversationHistory);
                this.ui.addCustomerSupport(this.conversationHistory.filter(m => m.role === 'user'));
                return;
            }

            if (response) {
                // Add bot response to UI

                console.log(response.answer);
                if(response.answer=="I don’t have an answer for this."){
                    // this.ui.addSupportMessage();
                    this.ui.saveCustomerMessage(message);
                    this.ui.addAskForUserDetails(this.conversationHistory.filter(m => m.role === 'user'));
                    
                    return;
                }

            if(response.answer=="It seems you need further assistance. Please reach out to our support team for help."){
                this.ui.saveCustomerMessage(message);
                console.log(this.conversationHistory);
                this.ui.addCustomerSupport(this.conversationHistory.filter(m => m.role === 'user'));
                return;
            }

                this.ui.addMessage(response.answer, 'bot');

                // Add to conversation history
                this.conversationHistory.push({
                    role: 'assistant',
                    content: response.answer
                });

                // Limit conversation history length (to prevent very long contexts)
                if (this.conversationHistory.length > 20) {
                    // Keep the first message (usually system prompt) and the last 19 messages
                    const firstMessage = this.conversationHistory[0];
                    this.conversationHistory = [
                        firstMessage,
                        ...this.conversationHistory.slice(-19)
                    ];
                }
            } else {
                // Show error message
                this.ui.addMessage('Sorry, I encountered an error. Please try again later.', 'bot');
                console.error('API error:', response.error);
            }
        } catch (error) {
            // Hide typing indicator
            this.ui.hideTypingIndicator();

            // Show error message
            this.ui.addMessage('Sorry, I\'m having trouble connecting to my brain right now. Please try again later.', 'bot');
            console.error('Error sending message:', error);
        }
    }

    /**
     * Handles when the chat is opened
     */
    handleChatOpen() {
        // Check API status when chat is opened
        //this.checkApiStatus();
    }

    /**
     * Opens the chat window
     */
    open() {
        if (this.ui && !this.ui.isOpen) {
            this.ui.toggleChat();
        }
    }

    /**
     * Closes the chat window
     */
    close() {
        if (this.ui && this.ui.isOpen) {
            this.ui.toggleChat();
        }
    }

    /**
     * Clears the conversation history
     */
    clearConversation() {
        this.conversationHistory = [];

        if (this.ui) {
            // Clear messages in UI
            const messagesContainer = this.ui.elements.messages;
            messagesContainer.innerHTML = '';

            // Add welcome message
            this.ui.addWelcomeMessage();
        }
    }
}

// Create and export a singleton instance
const chatbotWidget = new JsimpleBot();
export default chatbotWidget;
